/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import { createSelector } from "reselect";
import { getListViewObj, titles } from "./helper";
import { getauth } from "../auth/selectors";
import { SUPER_ADMIN_ROLE } from "../../constants/Constants";

export const getDatapipe = (state) => state.datapipe;
export const getActiveDatapipeLength = createSelector(
  [getDatapipe],
  (datapipe) =>
    datapipe.list.filter((eachDatapipe) => !eachDatapipe.disabled).length,
);

export const getCurrentDatapipePlayersVerified = createSelector(
  [getDatapipe],
  (datapipe) => datapipe && datapipe.currentDatapipePlayersVerified,
);
export const getInactiveDatapipeLength = createSelector(
  [getDatapipe],
  (datapipe) =>
    datapipe.list.filter((eachDatapipe) => !!eachDatapipe.disabled).length,
);
export const getDatapipeLength = createSelector(
  [getDatapipe],
  (datapipe) => datapipe.list.length,
);
export const getDatapipes = createSelector(
  [getDatapipe, getauth],
  (datapipe, auth) =>
    datapipe &&
    datapipe.list.map((datapipe1) => getListViewObj(datapipe1, auth)),
);
export const getTitles = createSelector([getauth], (auth) => {
  const titlesNow = JSON.parse(JSON.stringify(titles));
  if (auth && auth.user && auth.user.roleName === SUPER_ADMIN_ROLE) {
    titlesNow.push({
      key: "company",
      label: "Company",
      sortable: true,
      sortKey: "companyName",
    });
  }
  return titlesNow;
});
export const getDatapipeTotalCount = createSelector(
  [getDatapipe],
  (datapipe) => datapipe?.total,
);
export const getDatapipesLoadingStatus = createSelector(
  [getDatapipe],
  (datapipe) => ({
    loading: datapipe && datapipe.loading,
    loaded: datapipe && datapipe.loaded,
  }),
);
export const getCurrentDatapipe = createSelector([getDatapipe], (datapipe) =>
  datapipe && datapipe.currentDatapipe ? datapipe.currentDatapipe : {},
);
export const getCurrentDatapipeDel = createSelector([getDatapipe], (datapipe) =>
  datapipe && datapipe.currentDatapipeDel ? datapipe.currentDatapipeDel : {},
);
export const getToggleStatus = createSelector(
  [getDatapipe],
  /* istanbul ignore next */
  (datapipe) => ({
    togglingStatus: datapipe.togglingStatus,
    toggleStatusResponse: datapipe.toggleStatusResponse,
    toggleStatusError: datapipe.toggleStatusError,
  }),
);
export const DeleteDatapipeSuccessResponse = createSelector(
  [getDatapipe],
  // (datapipe) => datapipe.successResponse
  (datapipe) =>
    datapipe && datapipe.successResponse ? datapipe.successResponse : undefined,
);
export const getDatapipeSuccessResponse = createSelector(
  [getDatapipe],
  (datapipe) =>
    datapipe && datapipe.successResponse ? datapipe.successResponse : false,
);
export const getDatapipeError = createSelector([getDatapipe], (datapipe) =>
  datapipe && datapipe.error ? datapipe.error : null,
);
export const getSearchStore = createSelector([getDatapipe], (datapipe) =>
  datapipe && datapipe.storeSearch ? datapipe.storeSearch : null,
);
export const getDatapipeFilterStatus = createSelector(
  [getDatapipe],
  (datapipe) => (datapipe && datapipe.filter ? datapipe.filter : null),
);

export const getDatapipeHideSuccessResponse = createSelector(
  [getDatapipe],
  (datapipe) => datapipe?.hideDatapipeResponse,
);

export const getDatapipeHideErrorResponse = createSelector(
  [getDatapipe],
  (datapipe) => datapipe?.hideDatapipeErrorResponse,
);

export const getDatapipeLogs = createSelector(
  [getDatapipe],
  (datapipe) => datapipe?.datapipeLogs && datapipe?.datapipeLogs?.data,
);

export const getDatapipeLogsLoadingStatus = createSelector(
  [getDatapipe],
  (datapipe) => ({
    loading: datapipe?.datapipeLogLoading,
    loaded: datapipe?.datapipeLogLoaded,
  }),
);
